<template>
         <el-form-item label="经销商级别:">
               <el-select v-model="leve" @change="change">
                    <el-option :label="value.level_name" :value="value.id" v-for="(value,index) in leveList"  :key='index'></el-option>                           
                </el-select>
        </el-form-item>
</template>

<script>
export default {
    name:'dealerLeve',
    data(){
        return{
            leve:'',
            leveList:[
                {}
            ]
        }
    },
    created(){
        this.init()
    },
    watch:{
 
    },
    methods:{
        init(){
            this.$get('logistics','/dealers.level').then(res=>{
                this.leveList=res.data
                // this.$emit('leves',)
            })
        } ,
        change(){
              this.$emit('leves',this.leve)
        }
    }
}
</script>
